export const handleClickSeperator = (text: any, textRef: any, setText: any) => {
  const txtarea: any = textRef.current;
  if (txtarea) {
    const start = txtarea.selectionStart;
    const end = txtarea.selectionEnd;
    const finText =
      txtarea.value.substring(0, start) + text + txtarea.value.substring(end);
    txtarea.focus();
    txtarea.selectionEnd = end + 5;
    setText(finText);
  }
};

export const editBtnClickHandler = (
  setPreviewOn: any,
  quesArr: any,
  setText: any
) => {
  setPreviewOn(false);
  const text = quesArr
    ? quesArr.map((ques: any) => "\n--> " + ques).join("")
    : "\n--> ";
  setText(text);
};

// Helper function to get header title based on mode
export  const getHeaderTitle = (mode: 'view' | 'edit' | 'preview' | 'create') => {
    switch (mode) {
      case 'edit':
        return 'Edit Agenda';
      case 'preview':
        return 'Preview Agenda';
      case 'create':
        return 'Add New Agenda';
      default:
        return 'Agenda Preview';
    }
  };